import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-06811008"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  width: "37.5",
  height: "37.5",
  style: {
    "transform": "rotate(180deg)"
  },
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("polygon", {
  points: "18.75,1.875 35.625,35.625 1.875,35.625",
  "stroke-width": "3",
  fill: "none",
  stroke: "black"
}, null, -1));
const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = {
  key: 1,
  width: "37.5",
  height: "37.5",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("polygon", {
  points: "18.75,1.875 35.625,35.625 1.875,35.625",
  fill: "none",
  "stroke-width": "3",
  stroke: "black"
}, null, -1));
const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = {
  key: 2,
  width: "37.5",
  height: "37.5",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  width: "37.5",
  height: "37.5",
  fill: "none",
  stroke: "black",
  "stroke-width": "5"
}, null, -1));
const _hoisted_9 = [_hoisted_8];
const _hoisted_10 = {
  key: 3,
  width: "37.5",
  height: "37.5",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "18.75",
  cy: "18.75",
  r: "16.5",
  "stroke-width": "3",
  fill: "none",
  stroke: "black"
}, null, -1));
const _hoisted_12 = [_hoisted_11];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock(_Fragment, null, [$props.type == 0 ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3)) : _createCommentVNode("", true), $props.type == 1 ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6)) : _createCommentVNode("", true), $props.type == 2 ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_9)) : _createCommentVNode("", true), $props.type == 3 ? (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_12)) : _createCommentVNode("", true)], 64);
}